import { D as e } from "./luxon-88c249ba-ecb6bfbf.js";
const o = (a, t = "en-GB", r = "dd/mm/yyyy") => a === null ? r : (t === "en" && (t = "en-GB"), e.fromJSDate(a).setLocale(t).toLocaleString(e.DATE_SHORT)), f = (a, t) => {
  const r = a.startOf("day").setZone("utc"), s = t.startOf("day");
  return s && r < s;
}, y = (a, t) => {
  const r = a.startOf("day").setZone("utc"), s = t.startOf("day");
  return s && r > s;
};
export {
  y as a,
  o as g,
  f as i
};
